var _path, _circle, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeadMobile = function SvgHeadMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 311,
    height: 202,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-text, #EBEBEB)",
    d: "M5 96.958v.087c-1.223 0-1.935.744-1.935 1.955h-.122c0-1.22-.744-1.955-1.943-1.955v-.087c1.21 0 1.943-.745 1.943-1.958h.122c0 1.216.712 1.958 1.935 1.958M273 16.895v.217c-2.752 0-4.355 1.86-4.355 4.888h-.273c0-3.052-1.675-4.888-4.372-4.888v-.217c2.725 0 4.372-1.861 4.372-4.895h.273c0 3.04 1.603 4.895 4.355 4.895"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 17,
    r: 2.6,
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    strokeWidth: 0.8,
    d: "M288 137.916v.173c-2.447 0-3.871 1.489-3.871 3.911h-.243c0-2.442-1.489-3.911-3.886-3.911v-.173c2.422 0 3.886-1.489 3.886-3.916h.243c0 2.432 1.424 3.916 3.871 3.916Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-text, #EBEBEB)",
    d: "M298 43.937v.13c-1.835 0-2.903 1.117-2.903 2.933h-.183c0-1.831-1.116-2.933-2.914-2.933v-.13c1.816 0 2.914-1.117 2.914-2.937h.183c0 1.824 1.068 2.937 2.903 2.937"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    d: "M7.421 168.049c-2.14-9.974 4.232-15.23 10.057-17.979 14.06-6.636 31.153 8.101 24.641 13.743-6.511 5.643-18.073-18.448-6.28-25.813"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    d: "M234.913 88.4c0-40.435-29.679-73.187-66.393-73.187-36.715 0-66.394 32.752-66.394 73.186 0 13.101 3.073 25.312 8.573 35.987 8.976 17.548 13.343 37.119 13.343 56.851v7.601h89.036v-7.601c0-19.732 4.286-39.303 13.344-56.851a80.5 80.5 0 0 0 8.491-35.987Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    d: "M203.375 102.066S243 101.985 243 84.518c0-7.521-9.057-8.815-9.057-8.815"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    d: "M191.163 41.657h-100.6v96.558h100.6z"
  })));
};
export default SvgHeadMobile;